import { fetchAPI } from "@coworker/app/src/hooks/API/testbuy.service";
import { TYPES_OF_ARTICLES } from "@coworker/app/src/components/TestBuy/constants";
import { useQuery } from "@tanstack/react-query";
import {
  useCountryId,
  useMyStore,
  useStoreId,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";

const fetchRandomItems = async (
  area: string,
  storeId: string,
  userLanguage: string,
  testbuyTypeOfItems: string,
  countryId: string,
  articlesToExclude?: string[]
) => {
  return (await fetchAPI("testbuy/random_articles", "POST", {
    numberOfArticles: 6,
    area,
    storeId,
    locale: userLanguage,
    typeOfArticles: testbuyTypeOfItems ?? TYPES_OF_ARTICLES[1],
    countryId,
    articlesToExclude,
  })) as TestBuyProductWithCriteria[];
};

export const useGetRandomItems = (
  area: string,
  testbuyTypeOfItems: string,
  articlesToExclude?: string[]
) => {
  const storeId = useStoreId();
  const store = useMyStore();
  const countryId = useCountryId();
  const [userLanguage] = useUserPreference(
    profilePreferences.LANGUAGE,
    store?.primaryLocale
  );
  return useQuery({
    queryKey: ["get-random-items"],
    queryFn: async () => {
      return await fetchRandomItems(
        area,
        storeId,
        userLanguage,
        testbuyTypeOfItems,
        countryId,
        articlesToExclude
      );
    },
    staleTime: 0,
    enabled: false,
  });
};
